import React, { ReactElement } from "react";
import { Button } from "web/react/emo/button";
import { Text } from "web/react/emo/text";
import { VStack } from "web/react/emo/v-stack";
import { gettext } from "web/script/modules/django-i18n";
import { PaginatedCheckoutOrderHistorySerializer } from "web/types/serializers";
import { NoOrders } from "./no-orders";
import * as styles from "./order-history.css";
import { OrderList } from "./order-list";

export function OrderHistory({ results }: PaginatedCheckoutOrderHistorySerializer): ReactElement {
    const hasOrders = results && results.length > 0;

    return (
        <div className={styles.content}>
            {hasOrders ? (
                <VStack spacing="md">
                    <Text as="p" textStyle="hero-s" dataTestId="order-history-title">
                        {gettext("order_history.orders.title")}
                    </Text>

                    <OrderList orders={results} />

                    <div className={styles.helpSection} data-testid="help-section">
                        <VStack spacing="xs">
                            <Text as="p" textStyle="body-bold" dataTestId="help-section-title">
                                {gettext("order_history.help.title")}
                            </Text>
                            <Text as="p" textStyle="body-s" dataTestId="help-section-description">
                                {gettext("order_history.help.description")}
                            </Text>
                            <Button
                                title={gettext("order_history.help.button")}
                                variant="secondary"
                                width="full"
                                size="lg"
                                href="https://help.lyst.com/"
                                dataTestId="help-centre-button"
                            />
                        </VStack>
                    </div>
                </VStack>
            ) : (
                <NoOrders />
            )}
        </div>
    );
}
